import axios from "axios";
import auth from "../app/auth";

const uninterceptedClient = axios.create({
  headers: {
    Authorization: auth.auth.getSignInUserSession().getAccessToken().jwtToken,
  },
});

var order_api = {
  async get_order_status(order_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/order/status/${order_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async place_order(order_request, silent = false) {
    let axios_client = silent ? uninterceptedClient : axios;
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/order`;
    const response = await axios_client.post(request_url, order_request);
    return response;
  },
};

export default order_api;
